import React from "react";
import BaseEdge, { roundedOrthPath, roundTo } from "./BaseEdge"

// Rounded elbow edges — same as orthogonal but with larger radius.
export default function RoundEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  edgeControls,
  color,
}) {
  const fromNode = nodeById[edge.from];
  const toNode = nodeById[edge.to];
  if (!fromNode || !toNode) return null;

  const src = {
    x: roundTo(fromNode.x + fromNode.width / 2),
    y: roundTo(fromNode.y + fromNode.height / 2),
  };

  const dst = {
    x: roundTo(toNode.x + toNode.width / 2),
    y: roundTo(toNode.y + toNode.height / 2),
  };

  const ctrl = edgeControls?.[edgeIndex];
  const defaultMidX = Math.round((src.x + dst.x) / 2);

  const cp1 = ctrl?.cp1 ?? { x: defaultMidX, y: src.y };
  const cp2 = ctrl?.cp2 ?? { x: defaultMidX, y: dst.y };

  const pts = [src, cp1, cp2, dst];

  // larger rounding radius for smoother elbows
  const d = roundedOrthPath(pts, 14);

  const labelPos = {
    x: Math.round((cp1.x + cp2.x) / 2),
    y: Math.round((src.y + dst.y) / 2) - 12,
  };

  return (
    <BaseEdge
      d={d}
      stroke={color}
      onSelect={() => onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
    />
  );
}
